import React from 'react'

import { NavLink } from 'react-router-dom'

import { makeStyles } from '@material-ui/core/styles'

import clsx from 'clsx'

const useStyles = makeStyles((theme) => ({
	crumbInt: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center'
	},
	crumb: {
		fontFamily: 'Nunito',
		fontSize: 16,
		fontWeight: 'bold',
		textDecoration: 'none',
		color: '#3B0275',
		marginRight: 5,
		opacity: 0.6
	},
	selectedCrumb: {
		fontWeight: 800,
		fontSize: '16px',
		lineHeight: '22px',
		color: theme.palette.primary.main,
		opacity: 1,
		textTransform: 'uppercase'
	}
}))

const AdminCrumbs = (props) => {
	const { selectedFacility, location, client, selectedMarket } = props
	const classes = useStyles()

	const getLink = () => {
		if (location && location.pathname && location.pathname.includes('promos'))
			return (
				<NavLink className={clsx([classes.crumb, classes.selectedCrumb])} to={`/globalAdmin/promos`}>
					Promotions
				</NavLink>
			)

		if (location && location.pathname && location.pathname.includes('run-payments'))
			return (
				<NavLink className={clsx([classes.crumb, classes.selectedCrumb])} to={`/globalAdmin/run-payments`}>
					Run Payments
				</NavLink>
			)

		if (location && location.pathname && location.pathname.includes('appUpdate'))
			return (
				<NavLink className={clsx([classes.crumb, classes.selectedCrumb])} to={`/globalAdmin/appUpdate`}>
					App Update
				</NavLink>
			)

		if (location && location.pathname && location.pathname.includes('markets')) {
			if (
				(location.pathname.includes('home') ||
					location.pathname.includes('dash') ||
					location.pathname.includes('push')) &&
				selectedMarket
			) {
				return (
					<NavLink className={clsx([classes.crumb])} to={`/globalAdmin/markets`}>
						Markets /
					</NavLink>
				)
			} else {
				return (
					<NavLink className={clsx([classes.crumb, classes.selectedCrumb])} to={`/globalAdmin/markets`}>
						Markets
					</NavLink>
				)
			}
		}

		return (
			<NavLink className={clsx([classes.crumb, classes.selectedCrumb])} to={`/globalAdmin/markets`}>
				HOW'D YOU GET HERE?
			</NavLink>
		)
	}

	const getCity = () => {
		if (
			(location.pathname.includes('home') ||
				location.pathname.includes('dash') ||
				location.pathname.includes('push')) &&
			selectedMarket
		) {
			return (
				<NavLink
					className={clsx([classes.crumb, classes.selectedCrumb])}
					to={`/globalAdmin/markets/${selectedMarket._id}/home`}>
					{selectedMarket.city}, {selectedMarket.state}
				</NavLink>
			)
		}
		return null
	}

	return (
		<div className={classes.crumbInt}>
			<NavLink className={classes.crumb} to={`/globalAdmin/markets`}>
				Global Dashboard /
			</NavLink>

			{getLink()}
			{getCity()}
		</div>
	)
}

export default AdminCrumbs
